module.exports = __webpack_public_path__ + "static/img/图层 23.e89260bb.png";